export default class BestRoute {
  constructor(api) {
    this.api = api;
  }

  create(node, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/cables/bestroute", node)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  generate(data, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/cables/generate", data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/api/best_route.js